import {useEffect, useRef} from 'react';
import {useStore} from '@/store/root-store';
import {observer} from 'mobx-react-lite';
import styles from './styles.module.scss';
// import {EDIT_DEBOUNCE_WAIT} from '@/constants';
import {Toolkit as DraftToolkit} from '../EditorSection/content-editor/toolkit/toolkit';
import {Divider} from 'antd';
import {isNil} from 'lodash';
import {TargetKeywordsAndSuggestions} from './TargetKeywordsAndSuggestions/TargetKeywordsAndSuggestions';
import {BreadCrumb} from './bread-crumb';

interface Props {
  // allRef: any;
  newPage: any;
}

export const TopSection = observer(({newPage}: Props) => {
  const {contentOptimizer} = useStore('');
  const {currentPage} = contentOptimizer;
  const {
    setEditorHeightOffset,
    editorHeightOffset,
  } = currentPage;

  const headerKeywordsRef = useRef(null);

  const updateKeywordsRef = () => {
    if (!isNil(headerKeywordsRef?.current?.offsetHeight)) {
      setTimeout(() => {
        setEditorHeightOffset(editorHeightOffset?.breadcrumbHeight, headerKeywordsRef?.current?.offsetHeight || 0);
      }, 300);
    }
  };

  useEffect(() => {
    updateKeywordsRef();
  }, [headerKeywordsRef?.current]);

  return <><BreadCrumb
  // do not remove yet
  // customRef={allRef}
  />
  {!newPage && <div className={styles.headerKeywords} ref={headerKeywordsRef}>
    <TargetKeywordsAndSuggestions updateKeywordsRef={updateKeywordsRef}/>
    <Divider className={styles.popoverDivider} style={{margin: '7px 0px 7px 0px', minWidth: 'calc(100% - 115px)', width: 'calc(100% - 115px)'}} />
    <div className={styles.draftToolkit}>
      <DraftToolkit />
    </div>
  </div>}
  </>;
});
